<template>
  <b-container fluid class="text-center">
    <b-row class="text-left">
      <b-col class="bg-secondary pt-2" cols="4">
        <base-svg :svg="field.icon"></base-svg>
        <span class="pl-2">{{ field.fieldText }}</span>
      </b-col>
      <b-col cols="2">
        <b-form-select @change="onValueChange" :options="operators" :value="field.operator"
          v-model="field.operator"></b-form-select>
      </b-col>
      <b-col cols="6">
        <b-dropdown :id="`multi_select_${field.id}`" variant="primary" block split @change="onValueChange">
          <template #button-content>
            <div class="float-left" v-if="field.value.length === 0">Select</div>
            <div class="float-left" v-else-if="field.value.length === 1">
              {{ field.value[0].text }}
            </div>
            <div v-else>
              <div class="float-left">{{ field.value[0].text }}</div>
              <div class="float-right">
                <b-badge v-if="field.value.length > 0" pill variant="secondary">+ {{ field.value.length - 1 }}
                  {{ field.fieldText }}
                </b-badge>
              </div>
            </div>
          </template>
          <div class="dropdown-form-scrollable">
            <b-dropdown-form class="dropdown-form-scrollable">
              <b-form-group>
                <b-form-input v-model="filterValue" size="sm" debounce="100" placeholder="Search"></b-form-input>
              </b-form-group>
            </b-dropdown-form>
            <b-dropdown-item variant="primary" :active="field.value.includes(item)" v-for="item in filteredOptions"
              @click="onItemSelect(item)" :key="item.value">
              {{ item.text }}
            </b-dropdown-item>
          </div>
        </b-dropdown>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import localeService from '../../services/locales';

export default {
  name: 'LanguageTypeFilterElement',
  props: ['field'],
  data: () => ({
    filterValue: '',
    filteredOptions: [],
    operators: ['one of', 'none of'],
  }),
  watch: {
    filterValue(newValue) {
      this.filterValues(newValue);
    },
  },
  created() {
    this.filteredOptions = localeService.list();
  },
  methods: {
    onValueChange() {
      if (this.field.value.length > 0) {
        const valueMap = this.field.value.map(e => (this.field.operator === 'none of' ? `NOT "${e.value}"` : `"${e.value}"`));
        this.field.query = `(${this.field.key}:(${valueMap.join(' OR ')})) `;
        this.$emit('value-update');
      }
    },
    filterValues(filterValue) {
      if (filterValue === '') {
        this.filteredOptions = localeService.list();
      }
      this.filteredOptions = localeService.list()
        .filter(item => item.text.toLowerCase()
          .indexOf(filterValue.toLowerCase()) > -1);
    },
    onItemSelect(optionValue) {
      if (!this.field.value.includes(optionValue)) {
        this.field.value.push(optionValue);
      } else {
        const index = this.field.value.indexOf(optionValue);
        if (index > -1) {
          this.field.value.splice(index, 1);
        }
      }
      this.onValueChange();
    },
  },
};
</script>

<style scoped lang="scss">
.dropdown-form-scrollable {
  max-height: 400px;
  overflow-y: auto;

  .b-dropdown-form {
    padding: 0.25rem 0.5rem;
  }

  .form-group {
    margin-bottom: 0;
  }
}
</style>
